/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface CommunitySelectOption
 */
export interface CommunitySelectOption {
  /**
   * Unique identifier for this community
   * @type {number}
   * @memberof CommunitySelectOption
   */
  communityKey: number
  /**
   * The name of this community
   * @type {string}
   * @memberof CommunitySelectOption
   */
  name: string
  /**
   * The role keys that the current user is able invite for this community, based on the user's current roles/grants.
   * @type {Array<number>}
   * @memberof CommunitySelectOption
   */
  applicableRoleKeys: Array<number>
  /**
   * Bypasses the adobe sign agreements.
   * @type {boolean}
   * @memberof CommunitySelectOption
   */
  bypassAutomatedAgreements?: boolean
}

export function CommunitySelectOptionFromJSON(
  json: any
): CommunitySelectOption {
  return CommunitySelectOptionFromJSONTyped(json, false)
}

export function CommunitySelectOptionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CommunitySelectOption {
  if (json === undefined || json === null) {
    return json
  }
  return {
    communityKey: json['communityKey'],
    name: json['name'],
    applicableRoleKeys: json['applicableRoleKeys'],
    bypassAutomatedAgreements: !exists(json, 'bypassAutomatedAgreements')
      ? undefined
      : json['bypassAutomatedAgreements'],
  }
}

export function CommunitySelectOptionToJSON(
  value?: CommunitySelectOption | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    communityKey: value.communityKey,
    name: value.name,
    applicableRoleKeys: value.applicableRoleKeys,
    bypassAutomatedAgreements: value.bypassAutomatedAgreements,
  }
}
